module.exports = __webpack_public_path__ + "img/totem.ccffc72e.png";